import ProjectsApi from '@app/api/public/ProjectsApi';
import { useQuery } from 'react-query';

const useGetProjectArea = () => {
    return useQuery(['projectArea'], ProjectsApi.getProjectArea);
};

export default useGetProjectArea;
